<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>
<div class="tw-bg-gray-200 hero-bg">
    <div
        class="tw-min-h-[600px] tw-flex tw-items-center tw-max-w-[1200px] tw-mx-auto tw-px-[20px]"
    >
        <div
            class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-gap-[20px]"
        >
            <div
                class="tw-rounded-[16px] tw-shadow-lg tw-min-h-[205px] tw-w-[340px] md:tw-min-w-[340px] tw-flex tw-justify-center tw-items-center tw-bg-white"
            >
                <img
                    class="tw-max-w-[235px]"
                    [src]="miti?.image"
                    alt="Miti-Logo"
                />
            </div>
            <div
                class="tw-w-full tw-text-center md:tw-text-left tw-max-w-[475px] tw-text-[#0F268F]"
            >
                <h2 class="!tw-text-[32px] !tw-mb-[40px]">
                    {{ miti?.productName }}
                </h2>
                <span class="!tw-text-[14px]">{{
                    "GRANTS.DURATION" | translate
                }}</span>
                <p class="!tw-text-[24px] !tw-font-semibold">
                    {{
                        selectedLanguage === "en"
                            ? miti?.appStartdt
                            : miti?.appStartdtBm
                    }}
                    -
                    {{
                        selectedLanguage === "en"
                            ? miti?.appEnddt
                            : miti?.appEnddtBm
                    }}
                </p>
                <button
                    (click)="openDialog()"
                    class="tw-block tw-text-center tw-w-full tw-max-w-[60%] tw-bg-[#FF8717] tw-text-white tw-rounded-full tw-shadow-lg tw-mx-auto md:tw-mx-0 tw-py-[15px]"
                >
                    {{ "GRANTS.APPLY" | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
<div
    class="tw-my-[50px] tw-max-w-[1200px] tw-border-t-2 tw-pt-[30px] tw-border-t-[#F68723] tw-mx-auto tw-px-[15px]"
>
    <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-[20px]">
        <div class="tw-flex-[1]">
            <ul
                class="tw-flex tw-flex-row tw-max-w-[90vw] tw-pb-[20px] md:tw-max-w-max tw-w-full md:tw-flex-col tw-overflow-x-auto tw-gap-[20px] tw-text-[#A7A7A7] tw-font-semibold tw-text-[20px]"
            >
                <li
                    *ngFor="let nav of sideNav"
                    (click)="setTab(nav)"
                    class="hover:tw-cursor-pointer tw-min-w-fit"
                    [ngClass]="
                        nav?.slug === selectedTab &&
                        'tw-text-[#0F268F] !tw-underline !tw-underline-offset-8'
                    "
                >
                    {{ nav.title | translate }}
                </li>
            </ul>
        </div>
        <div class="tw-flex-[3]">
            <div class="tw-max-w-[520px] tw-mx-auto">
                <h2 class="!tw-uppercase !tw-font-semibold !tw-mb-4">
                    {{ selectedHeading | translate }}
                </h2>
                <p class="content" [innerHTML]="content"></p>
            </div>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-[20px] tw-flex-[2]">
            <div class="">
                <h4
                    class="!tw-text-[24px] !tw-text-[#0F268F] !tw-font-semibold"
                >
                    {{ "GRANTS.GRANTS_SUMMRY" | translate }}
                </h4>
                <p class="!tw-text-[14px] tw-text-[#575757]">
                    {{
                        selectedLanguage === "en"
                            ? miti?.prodShortDesc
                            : miti?.prodShortDescBm
                    }}
                </p>
            </div>

            <div class="">
                <button
                    (click)="openDialog()"
                    class="tw-block tw-text-center tw-w-full tw-max-w-[80%] tw-bg-[#FF8717] tw-text-white tw-rounded-full tw-shadow-lg tw-mx-auto md:tw-mx-0 tw-my-[10px] tw-py-[15px]"
                >
                    {{ "GRANTS.APPLY" | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
<div
    class="tw-min-h-[160px] tw-flex tw-items-center tw-bg-[#EFEFEF] tw-py-[50px]"
>
    <div
        class="tw-max-w-[100vw] md:tw-max-w-[1200px] tw-mx-auto tw-overflow-x-auto tw-w-full tw-px-[20px] tw-flex tw-justify-start md:tw-justify-center tw-gap-[50px]"
    >
        <img
            *ngFor="let img of imgs"
            [src]="img"
            alt="Miti-Logo"
            class="tw-max-w-[200px] footer-img"
        />
    </div>
</div>
<app-footer></app-footer>
